/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var einsteinActivities = __webpack_require__(89);

	/**
	 * fills in the carousel with product tile html objects
	 * @param {string} einsteinResponse string html for product tiles
	 * @param {jQuery} $parentElement parent element where recommendations will show.
	 */
	function fillDomElement(einsteinResponse, $parentElement) {
	    var recommender = $parentElement.data('recommender');
	    var recommendedProducts = einsteinResponse[recommender].recs;
	    if (recommendedProducts && recommendedProducts.length > 0) {
	        var components = [];
	        components = recommendedProducts.map(function (recommendedProduct) {
	            var tiledefinition = {};
	            tiledefinition.model = {
	                type: 'product',
	                id: recommendedProduct.id
	            };
	            return tiledefinition;
	        });

	        var url = new URL($parentElement.data('product-load-url'));
	        url.searchParams.append('components', JSON.stringify(components));
	        // SFRA6 migration, not used but implemented for possible new features
	        url.searchParams.append('recommender', recommender);
	        // Needed so request.httpParameterMap.cnstrcItem is set when tiles render
	        url.searchParams.append('cnstrcItem', 'recommendation');
	        $.ajax({
	            url: url.href,
	            type: 'get',
	            dataType: 'html',
	            success: function success(html) {
	                $parentElement.find('.multiple-items').html(html);

	                // Tag as a recommendation pod only once content has loaded, so
	                // empty hover-lazy carousels don't surface as empty pods.
	                $parentElement.attr('data-cnstrc-recommendations', '');
	                $parentElement.attr('data-cnstrc-num-results', recommendedProducts.length);

	                $('body').trigger('einsteinCarousel:setup', $parentElement);

	                einsteinActivities.sendViewReco(recommendedProducts.map(function (product) {
	                    return product.id;
	                }));
	            },
	            error: function error() {
	                $parentElement.spinner().stop();
	            }
	        });
	    }
	}

	/**
	 * Processes a recommendation tile, with an already initialized category specific anchors array
	 * @param {jQuery} $parentElement parent element where recommendations will show.
	 * @param {Object} einsteinUtils cquotient object
	 * @param {Array} anchorsArray array of objects representing anchors
	 */
	function processRecommendationsTile($parentElement, einsteinUtils, anchorsArray, onComplete, onError) {
	    var recommender = $parentElement.data('recommender');

	    var params = {
	        userId: einsteinUtils.getCQUserId(),
	        cookieId: einsteinUtils.getCQCookieId(),
	        ccver: '1.01'
	    };

	    if (anchorsArray) {
	        params.anchors = anchorsArray;
	    }

	    /**
	     * Processes a recommendation responses
	     * @param {Object} einsteinResponse cquotient object
	     */
	    function recommendationsReceived(einsteinResponse) {
	        fillDomElement(einsteinResponse, $parentElement);
	        $parentElement.spinner().stop();
	        if (onComplete) {
	            onComplete();
	        }
	    }

	    try {
	        if (einsteinUtils.getRecs) {
	            einsteinUtils.getRecs(einsteinUtils.clientId, recommender, params, recommendationsReceived);
	        } else {
	            einsteinUtils.widgets = einsteinUtils.widgets || []; // eslint-disable-line no-param-reassign
	            einsteinUtils.widgets.push({
	                recommenderName: recommender,
	                parameters: params,
	                callback: recommendationsReceived
	            });
	        }
	    } catch (e) {
	        if (onError) {
	            onError(e);
	        }
	    }
	}

	/**
	 * Processes a recommendation tile, with an already initialized product specific anchors array
	 * @param {jQuery} $parentElement parent element where recommendations will show.
	 * @returns {Array} - containing an anchor object
	 */
	function createProductAnchor($parentElement) {
	    return [{
	        id: $parentElement.data('primaryProductId'),
	        sku: $parentElement.data('secondaryProductId'),
	        type: $parentElement.data('alternativeGroupType'),
	        alt_id: $parentElement.data('alternativeGroupId')
	    }];
	}

	/**
	 * Rerieves data attributes from parent element and converts to gretel compatible recommenders array
	 * @param {jQuery} $parentElement parent element where recommendations will show.
	 * @returns {Array} - containing an anchor object
	 */
	function createCategoryAnchor($parentElement) {
	    return [{ id: $parentElement.data('categoryId') }];
	}

	/**
	 * Loads a single recommendation carousel, guarded against double-loading.
	 * @param {jQuery} $parentElement parent element where recommendations will show.
	 * @param {Object} einsteinUtils cquotient object
	 */
	function loadSingleRecommendation($parentElement, einsteinUtils) {
	    if ($parentElement.data('einsteinLoading') || $parentElement.data('einsteinLoaded')) {
	        return;
	    }
	    $parentElement.data('einsteinLoading', true);
	    $parentElement.spinner().start();

	    function onComplete() {
	        $parentElement.data('einsteinLoaded', true);
	        $parentElement.data('einsteinLoading', false);
	    }

	    function onError() {
	        $parentElement.data('einsteinLoading', false);
	        $parentElement.spinner().stop();
	    }

	    if ($parentElement.closest('.experience-einstein-einsteinCarouselProduct').length || $parentElement.closest('.experience-einstein-einsteinCarouselProductLH').length) {
	        return processRecommendationsTile($parentElement, einsteinUtils, createProductAnchor($parentElement), onComplete, onError);
	    } else if ($parentElement.closest('.experience-einstein-einsteinCarouselCategory').length || $parentElement.closest('.experience-einstein-einsteinCarouselCategoryLH').length || $parentElement.closest('.experience-einstein-einsteinMenuTrendingCarousel').length) {
	        return processRecommendationsTile($parentElement, einsteinUtils, createCategoryAnchor($parentElement), onComplete, onError);
	    }
	    return processRecommendationsTile($parentElement, einsteinUtils, null, onComplete, onError);
	}

	/**
	 * Gets all placeholder elements, which hold einstein recommendations queries the details from the
	 * einstein engine and feeds them back to the dom element.
	 * Excludes menu trending carousels — those are loaded lazily on menu hover.
	 */
	function loadRecommendations() {
	    var einsteinUtils = einsteinActivities.getEinsteinUtils();
	    if (einsteinUtils) {
	        var $recommendationTiles = $('.js-einstein-carousel:not(.cc-recommended-slider__carousel-wrp-menu-trending)');
	        $recommendationTiles.each(function () {
	            loadSingleRecommendation($(this), einsteinUtils);
	        });
	    }
	}

	/**
	 * Lazily loads menu trending carousels on first hover/focus of their parent menu item.
	 * Prevents all menu carousels from firing on page load and causing 429s.
	 * einsteinUtils is resolved at hover time to avoid CQuotient timing issues.
	 */
	function initMenuTrendingCarousels() {
	    $('body').on('mouseenter focusin', '.js-menuFirstLevelItem', function () {
	        var einsteinUtils = einsteinActivities.getEinsteinUtils();
	        if (!einsteinUtils) {
	            return;
	        }
	        $(this).find('.cc-recommended-slider__carousel-wrp-menu-trending').each(function () {
	            loadSingleRecommendation($(this), einsteinUtils);
	        });
	    });
	}

	$(document).ready(function () {
	    // Only initialize if not already initialized
	    if (!window.einsteinInitialized) {
	        window.einsteinInitialized = true;
	        loadRecommendations();
	        initMenuTrendingCarousels();
	    }
	});

	// eslint-disable-next-line no-undef
	if (true) {
	    module.exports = { loadRecommendations: loadRecommendations, initMenuTrendingCarousels: initMenuTrendingCarousels, loadSingleRecommendation: loadSingleRecommendation };
	}

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

	'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var CCVER = '1.01';

	/**
	 * Validates and returns the CQuotient namespace provided by Commerce Cloud.
	 * @returns {Object|null} einsteinUtils or null
	 */
	function getEinsteinUtils() {
	    var einsteinUtils = window.CQuotient;
	    if (einsteinUtils && typeof einsteinUtils.getCQUserId === 'function' && typeof einsteinUtils.getCQCookieId === 'function') {
	        return einsteinUtils;
	    }
	    return null;
	}

	/**
	 * @param {Object} einsteinUtils - CQuotient instance
	 * @param {Array<{id: string}>} products - product id objects
	 * @returns {Object} activity payload
	 */
	function buildActivityParams(einsteinUtils, products) {
	    return {
	        userId: einsteinUtils.getCQUserId(),
	        cookieId: einsteinUtils.getCQCookieId(),
	        ccver: CCVER,
	        products: products
	    };
	}

	/**
	 * Normalizes product id(s) to Einstein activity product objects.
	 * @param {string|Array<string|{id: string}>} productIds - one id or many
	 * @returns {Array<{id: string}>}
	 */
	function normalizeProducts(productIds) {
	    var list = Array.isArray(productIds) ? productIds : [productIds];
	    return list.map(function (entry) {
	        if (entry && (typeof entry === 'undefined' ? 'undefined' : _typeof(entry)) === 'object') {
	            return entry.id;
	        }
	        return entry;
	    }).filter(function (id) {
	        return id !== null && typeof id !== 'undefined' && id !== '';
	    }).map(function (id) {
	        return { id: String(id) };
	    });
	}

	/**
	 * @param {string} activityName - Einstein activity type (gretel-supported)
	 * @param {string|Array<string|{id: string}>} productIds - product id(s)
	 */
	function sendActivity(activityName, productIds) {
	    var einsteinUtils = getEinsteinUtils();
	    var products = normalizeProducts(productIds);

	    if (!einsteinUtils || typeof einsteinUtils.sendActivity !== 'function' || products.length === 0) {
	        return;
	    }

	    try {
	        einsteinUtils.sendActivity(einsteinUtils.clientId, activityName, buildActivityParams(einsteinUtils, products));
	    } catch (e) {
	        // console.error('Error sending ' + activityName + ' activity:', e);
	        return;
	    }
	}

	/**
	 * Fired when a recommendation zone is displayed (all visible products).
	 * @param {Array<string|{id: string}>} productIds - recommended product ids
	 */
	function sendViewReco(productIds) {
	    sendActivity('viewReco', productIds);
	}

	/**
	 * Fired when a shopper clicks a product in an Einstein recommendation zone.
	 * @param {string} productId - clicked product id
	 */
	function sendClickReco(productId) {
	    sendActivity('clickReco', productId);
	}

	/**
	 * Fired when a shopper clicks a product from search (e.g. Constructor autocomplete).
	 * @param {string} productId - clicked product id
	 */
	function sendClickSearch(productId) {
	    sendActivity('clickSearch', productId);
	}

	module.exports = {
	    getEinsteinUtils: getEinsteinUtils,
	    sendViewReco: sendViewReco,
	    sendClickReco: sendClickReco,
	    sendClickSearch: sendClickSearch,
	    sendActivity: sendActivity,
	    normalizeProducts: normalizeProducts
	};

/***/ })

/******/ });